<template>
	<div class="applets">
		<div class="empower-box">
			<div class="title-box">
				<p class="title">授权小程序</p>
			</div>
			<div class="content-box" v-if="!state">
				<p class="title">授权小程序后，即可发布小程序</p>
				<div class="text">
					<p class="txt">1、微信官方规定：用户需授权小程序后，第三方平台才能对小程序进行设计和代码管理。</p>
					<p class="txt">2、微信官方规定：小程序个人开放的服务类目是有严格规定的，内容不在服务类目中的，是审核不通过的。<span class="details_url"
							@click="toTxDetails">查看详情</span></p>
				</div>
				<div class="btn-box">
					<el-button class="empower-btn" @click="toWeb">我已有小程序，直接授权</el-button>
					<!--          <el-button class="register-btn">注册小程序账号</el-button>-->
				</div>
			</div>
			<div class="info-box" v-else>
				<div class="app-img">
					<img :src="info.head_image" alt="">
				</div>
				<div class="info">
					<div class="info-text">
						<p class="name">{{ info.nick_name }}</p>
						<p class="state">发布状态：
							<span class="co" v-if="info.status === 0">未发布</span>
							<span class="co" v-else-if="info.status === 1">审核中</span>
							<span class="co" v-else-if="info.status === 2">审核失败</span>
							<span class="co" v-else-if="info.status === 3">审核延后</span>
							<span class="co" v-else-if="info.status === 4">审核成功</span>
						</p>
						<p class="fail" v-if="info.status === 2">{{info.reason}}</p>
					</div>

					<el-button class="to_examine" @click="releaseApplets" v-if="info.status === 0">提交审核</el-button>
					<el-button class="to_examine" @click="releaseApplets" v-else-if="info.status === 2">重新提交审核
					</el-button>
					<el-button class="to_examine" disabled v-else>审核中</el-button>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import {
		getAppletsInfo,
		getAppletsAuthUrl,
		setAppletsAuthInfo,
		releaseApplets
	} from 'network/hk_miniapp'
	
	import {
		retujudpower,
		retupower,
		alertMess,
	} from '@src/network/kh_public'

	export default {
		name: "Applets",
		data() {
			return {
				is_powerAdd: false,
				is_powerEdit: false,
				is_powerDel: false,
				is_powerImp: false,
				is_powerExp: false,
				is_powerRec: false,
				
				info: {},
				state: false
			}
		},
		created() {
			var auth_code = this.$route.query.auth_code
			if (auth_code) {
				auth_code = decodeURIComponent(auth_code)
				this.setAppletsAuthInfo(auth_code)
			} else {
				this.getAppletsInfo()
			}

		},
		methods: {
			judgePower() {
				this.is_powerAdd = retupower('205')
				this.is_powerEdit = retupower('206')
				this.is_powerDel = retupower('207')
				this.is_powerImp = retupower('208')
				this.is_powerExp = retupower('209')
				this.is_powerRec = retupower('210')
			},
			toTxDetails() {
				window.open('https://kf.qq.com/faq/170925EzEnIb1709256Vvyy6.html', '__brank')
			},
			toWeb() {
				if(retujudpower(this.is_powerEdit)) {
					this.getAppletsAuthUrl(window.location.href)
				}
				
			},

			// 判断是否授权
			getAppletsInfo() {
				getAppletsInfo().then(res => {
					if (res.code === 10000) {
						this.info = res.result
						this.state = true
					} else {
						this.state = false
					}

				})
			},
			// 跳转到授权页面
			getAppletsAuthUrl(url) {
				getAppletsAuthUrl(url).then(res => {
					if (res) {
						if (res.code === 10000) {
							window.open(res.result, '_blank')
						} else {
							this.$message({
								showClose: true,
								message: res.message,
								duration: 2000,
								type: 'error',
								offset: 100,
							});
						}
					}

				})
			},

			setAppletsAuthInfo(authorization_code) {
				setAppletsAuthInfo(authorization_code).then(res => {
					if (res) {
						if (res.code === 10000) {
							this.getAppletsInfo()
						} else {
							this.$message({
								showClose: true,
								message: res.message,
								duration: 2000,
								type: 'error',
								offset: 100,
							});
						}
					}

				})
			},

			releaseApplets() {
				if(retujudpower(this.is_powerEdit)) {
					releaseApplets().then(res => {
						if (res.code === 10000) {
							this.$message({
								message: '提交成功',
								type: 'success',
								offset: 100
							});
					
						}
					})
				}
				
			},
		}
	}
</script>

<style scoped>
	.applets {
		width: 100%;
		/* padding: 5px; */
		box-sizing: border-box;
	}

	.applets .empower-box {
		width: 100%;
		background: #fff;
	}

	.applets .empower-box .title-box {
		padding: 30px;
		border-bottom: 1px dashed #e6e7ec;
	}

	.applets .empower-box .title-box .title {
		font-size: 18px;
		color: #353535;
	}

	.applets .empower-box .content-box {
		width: 100%;
		padding: 60px;
		display: flex;
		flex-direction: column;
		align-items: center;
		box-sizing: border-box;
	}

	.applets .empower-box .content-box .title {
		font-size: 22px;
		color: #333;
	}

	.applets .empower-box .content-box .text {
		margin-top: 15px;
	}

	.applets .empower-box .content-box .text .txt {
		font-size: 14px;
		color: #888;
		margin: 5px 0;
	}

	.applets .empower-box .content-box .details_url {
		cursor: pointer;
		color: var(--themeColors);
	}

	.applets .empower-box .content-box .btn-box {
		margin-top: 25px;
	}

	.applets .empower-box .content-box .btn-box .empower-btn {
		padding: 8px 15px;
		background: var(--themeColors);
		color: #fff;
		border: none;
		margin-right: 20px;
	}

	.applets .empower-box .content-box .btn-box .empower-btn:hover {
		background: var(--themeColorsHover);
	}

	.applets .empower-box .content-box .btn-box .register-btn {
		padding: 8px 15px;
	}

	.applets .empower-box .info-box {
		width: 100%;
		padding: 60px;
		display: flex;
		box-sizing: border-box;
		justify-content: center;
	}

	.applets .empower-box .info-box .app-img {
		width: 132px;
		height: 132px;
		border: 1px solid #e3e2e8;
		border-radius: 50%;
		overflow: hidden;
	}

	.applets .empower-box .info-box .app-img img {
		width: 100%;
		height: 100%;
	}

	.applets .empower-box .info-box .info {
		margin-left: 100px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.applets .empower-box .info-box .info .info-text .name {
		font-size: 20px;
		color: #353535;
	}

	.applets .empower-box .info-box .info .info-text .state {
		color: #666;
		font-size: 14px;
		margin-top: 10px;
	}

	.applets .empower-box .info-box .info .info-text .state .co {
		color: rgb(244, 158, 55);
	}

	.applets .empower-box .info-box .info .info-text .fail {
		color: #e62918;
		font-size: 14px;
		margin-top: 10px;
	}

	.applets .empower-box .info-box .info .to_examine {
		padding: 8px 15px;
		background: var(--themeColors);
		color: #fff;
		border: none;
		margin-right: 20px;
	}

	.applets .empower-box .info-box .info .to_examine:hover {
		background: var(--themeColorsHover);
	}
</style>
